import { IconProps } from "../../types/utils";

const CreateNew = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.3182 4H11.3918C9.8302 4 8.5502 5.28 8.5502 6.8416V8.71035H6.68144C5.11984 8.71035 3.83984 9.99036 3.83984 11.552V25.504C3.83984 27.0656 5.11984 28.3456 6.68144 28.3456H20.6078C22.1694 28.3456 23.4494 27.0656 23.4494 25.504V23.6352H25.3182C26.8798 23.6352 28.1598 22.3552 28.1598 20.7936V6.8416C28.1598 5.28 26.8798 4 25.3182 4ZM21.3502 25.4784C21.3502 25.888 21.0173 26.2207 20.6078 26.2207H6.68144C6.2718 26.2207 5.93914 25.8879 5.93914 25.4784V11.552C5.93914 11.1424 6.27199 10.8097 6.68144 10.8097H20.6078C21.0175 10.8097 21.3502 11.1425 21.3502 11.552V25.4784ZM26.0606 20.768C26.0606 21.1776 25.7277 21.5103 25.3182 21.5103H23.4495V11.5519C23.4495 9.99031 22.1695 8.71031 20.6079 8.71031H10.6239V6.84155C10.6239 6.43191 10.9567 6.09925 11.3662 6.09925H25.3182C25.7278 6.09925 26.0605 6.4321 26.0605 6.84155L26.0606 20.768Z"
      fill={color || "#242424"}
    />
    <path
      d="M18.0242 17.4712H14.696V14.1432C14.696 13.5544 14.2353 13.0935 13.6463 13.0935C13.0575 13.0935 12.5966 13.5542 12.5966 14.1432V17.4712H9.26844C8.67966 17.4712 8.21875 17.9319 8.21875 18.5208C8.21875 18.8025 8.34679 19.084 8.52591 19.2632C8.7052 19.4424 8.98664 19.5703 9.26825 19.5703H12.5964V22.8983C12.5964 23.18 12.7245 23.4615 12.9036 23.6407C13.0829 23.8199 13.3643 23.9478 13.6459 23.9478C14.2347 23.9478 14.6956 23.4871 14.6956 22.8982V19.5701H18.0238C18.6126 19.5701 19.0735 19.1094 19.0735 18.5205C19.0739 17.9321 18.5874 17.4712 18.0242 17.4712L18.0242 17.4712Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default CreateNew;
